import SideMenu from '@/containers/side-menu/SideMenu.vue';
import RegisterPointOfInterest from '@/pages/register-point-of-interest/RegisterPointOfInterest.vue';

export default {
  path: '/register-point-of-interest',
  name: 'RegisterPointOfInterest',
  components: {
    mainContent: RegisterPointOfInterest,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'point-of-interest',
    },
    breadcrumb: {
      title: 'Pontos de interesse',
      paths: [{ title: 'Cadastro' }],
    },
  },
};
